<template>
    <div class="config-call">
        <div class="table-config">
            <div class="list-configs">
                <div class="config-item"
                     v-for="config in listConfigs"
                     :key="config.id"
                     :class="idConfigActive === config.id ? 'config-actived' : ''"
                     @click="idConfigActive = config.id"
                >
                    {{ config.name }}
                </div>
            </div>
            <div class="config-box fci-scrollbar">
                <AutoCallConfig ref="AutoCallConfig" v-show="idConfigActive === 'auto-call'"></AutoCallConfig>
                <VoiceProfileInboundConfig ref="VoiceProfileInboundConfig"
                                           v-show="idConfigActive === 'voice-profile-inbound'"></VoiceProfileInboundConfig>
                <CallTreatmentConfig ref="CallTreatmentConfig"
                                     v-show="idConfigActive === 'call-treatment'"></CallTreatmentConfig>
                <EmailReportConfig ref="EmailReportConfig"
                                   v-show="idConfigActive === 'report-via-mail'"></EmailReportConfig>
                <BlackListConfig ref="BlackListConfig"
                                 v-show="idConfigActive === 'black-list'"></BlackListConfig>
                <DataCollectionMappingConfig ref="DataCollectionMappingConfig"
                                             v-show="idConfigActive === 'data-collection-mapping'"></DataCollectionMappingConfig>
                <CampaignInfoConfig ref="CampaignInfoConfig"
                                    v-show="idConfigActive === 'information'"
                                    v-if="!useTovaOrVoiceAgent"></CampaignInfoConfig>
                <CampaignInfoConfig2 ref="CampaignInfoConfig"
                                     v-show="idConfigActive === 'information'"
                                     v-if="useTovaOrVoiceAgent"></CampaignInfoConfig2>
                <AdvancedSetting ref="AdvancedSetting" v-show="idConfigActive === 'advanced'"></AdvancedSetting>
                <DataMemoryMapping ref="DataMemoryMapping"
                                   v-show="idConfigActive === 'data-memory-mapping'"></DataMemoryMapping>
            </div>
        </div>
        <div class="step-actions" v-if="isStep">
            <div v-if="canGoBack" @click="goBack" class="btn-custom btn-back mr-8">
                {{ backTitle || $t('back') | capitalize }}
            </div>
            <div @click="save" color="primary" class="btn-custom">
                {{ $f.tc('saveAll') }}
            </div>
            <div v-if="!$route.params.campaignId" @click="goToCampaign"
                 class="btn-custom ml-8">
                {{ $f.tc('gotoCreatedCampaign') }}
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import EmailReportConfig from "@/views/Campaign/Form/Step4/EmailReportConfig";
import DataCollectionMappingConfig from "@/views/Campaign/Form/Step4/DataCollectionMappingConfig";
import BlackListConfig from "@/views/Campaign/Form/Step4/BlackListConfig";
import CallTreatmentConfig from "@/views/Campaign/Form/Step4/CallTreatmentConfig";
import CampaignService from "@/services/campaign.service";
import AutoCallConfig from "@/views/Campaign/Form/Step4/AutoCallConfig";
import CampaignInfoConfig from "@/views/Campaign/Form/Step4/CampaignInfoConfig";
import VoiceProfileInboundConfig from "@/views/Campaign/Form/Step4/VoiceProfileInboundConfig";
import AdvancedSetting from "@/views/Campaign/Form/Step4/AdvancedSettings.vue";
import utils from "@/utils/utils";
import CampaignInfoConfig2 from "@/views/Campaign/Form/Step4/CampaignInfoConfig2.vue";
import DataMemoryMapping from "@/views/Campaign/Form/Step4/DataMemoryMapping.vue";

export default {
    name: 'NewCampaignStep4',
    components: {
        AdvancedSetting,
        CampaignInfoConfig,
        AutoCallConfig,
        EmailReportConfig,
        DataCollectionMappingConfig,
        BlackListConfig,
        CallTreatmentConfig,
        VoiceProfileInboundConfig,
        CampaignInfoConfig2,
        DataMemoryMapping,
    },
    props: {
        next: Function,
        nextTitle: String,
        back: Function,
        canGoBack: Boolean,
        backTitle: String,
        isStep: Boolean
    },
    data() {
        return {
            idConfigActive: ''
        }
    },
    computed: {
        utils() {
            return utils
        },
        ...mapState({
            campaign: state => state.campaign.campaign,
            campaignConfig: state => state.campaign.campaignConfig,
        }),
        listConfigs() {
            let configs = [
                {
                    id: 'report-via-mail',
                    name: this.$f.tc('reportViaMail')
                },
                {
                    id: 'data-collection-mapping',
                    name: this.$f.tc('dataCollectionMapping')
                },
                {
                    id: 'data-memory-mapping',
                    name: this.$f.tc('dataMemoryMapping')
                },
                {
                    id: 'black-list',
                    name: this.$f.tc('blackList')
                }
            ]
            if (this.campaign && this.campaign.direction === 'OUTBOUND') {
                configs.unshift({
                    id: 'call-treatment',
                    name: this.$f.tc('callTreatment')
                })
                configs.unshift({
                    id: 'auto-call',
                    name: this.$f.tc('autoCall')
                })
            }
            if (!this.isStep) {
                configs.push({
                    id: 'information',
                    name: this.$f.tc('campaignInfo')
                })
                configs.push({
                    id: 'advanced',
                    name: this.$f.tc('advancedSettings')
                })
            }
            if (this.campaign && this.campaign.direction === 'INBOUND') {
                configs.unshift({
                    id: 'voice-profile-inbound',
                    name: this.$f.tc('voiceProfile')
                })
            }
            return configs
        },
        useTovaOrVoiceAgent() {
            return utils.enableTovaAgent() || utils.enableVoiceAgent()
        }
    },
    mounted() {
        this.idConfigActive = (this.campaign && this.campaign.direction === 'OUTBOUND') ? 'auto-call' : 'voice-profile-inbound'
        this.$appService.showLoading()
        Promise.all([this.getCampaign(), this.getCampaignConfig()]).finally(this.$appService.hideLoading)
    },
    methods: {
        getCampaign() {
            return CampaignService.getCampaign(this.campaign.id).then(res => {
                return this.$store.dispatch(this.$actionTypes.campaign.SET_DATA, res.data)
            })
        },
        getCampaignConfig() {
            return this.$store.dispatch(this.$actionTypes.campaign.GET_CAMPAIGN_CONFIG, this.campaign.id)
        },
        save() {
            if (this.campaign.direction === 'OUTBOUND') {
                this.$refs.AutoCallConfig.submit()
                this.$refs.CallTreatmentConfig.submit()
            }
            this.$refs.EmailReportConfig.submit()
            this.$refs.DataCollectionMappingConfig.submit()
            if (this.campaign && this.campaign.enable_black_list === true) {
                this.$refs.BlackListConfig.submit()
            }
        },
        goBack() {
            if (typeof this.back === 'function') {
                this.back()
            }
        },
        goToCampaign() {
            this.save()
            this.$router.push('/campaign/' + this.campaign.id + '/')
        }
    }
}
</script>
<style scoped lang="scss">
::v-deep {
    .v-card__title {
        font-size: 16px;
        font-weight: bold;
    }

    .title-config {
        .title {
            font-family: "open sans bold", serif !important;
            text-transform: capitalize;
        }
    }
}

.config-call {
    margin: 28px 0 0;
    font-family: "open sans", serif !important;
}

.table-config {
    border: 1px solid #D9D9D9;
    border-radius: 5px;
    display: flex;
    align-items: stretch;
    margin: 0 auto;
    width: 1024px;

    .list-configs {
        width: 300px;
        font-size: 14px;
        border-right: 1px solid #E4EDFA;
    }

    .config-actived {
        background: #e4edfa;
        font-weight: 700;
        color: #0052cc;
    }

    .config-item {
        height: 44px;
        line-height: 44px;
        padding: 0 12px;
        cursor: pointer;
        border-bottom: 1px solid #E4EDFA;
        text-transform: capitalize;

        &:hover {
            background: #F5F5F5;
        }
    }

    .config-box {
        flex: 1;
        //height: calc(100vh - 469px);
        overflow-y: auto;
    }
}

.step-actions {
    margin-top: 24px;
}

.config-content {
    padding: 20px;
    height: calc(100vh - 576px);
    overflow-y: auto;
}
</style>
